module.exports = __webpack_public_path__ + "img/mastercard-gold.f3db0c9c.png";